import type { FC } from "react";

import { Checkbox, Link } from "@aviary";
import { sharedRoutes } from "@shared/data/sharedRoutes";

interface Props {
  updateTimestamp: (date: Date | "") => void;
}

const TermsOfServiceCheckbox: FC<Props> = ({ updateTimestamp }) => {
  const handleCheckboxClick = e => {
    if (e.target.checked) {
      const date = new Date();
      updateTimestamp(date);
    } else {
      updateTimestamp("");
    }
  };

  return (
    <Checkbox data-e2e="tos_checkbox" onClick={handleCheckboxClick}>
      I agree to Fullscript's{" "}
      <Link href={sharedRoutes.external.termsOfService} noExternalIcon>
        Terms of Service
      </Link>{" "}
      and{" "}
      <Link href={sharedRoutes.external.privacyPolicy} noExternalIcon>
        Privacy Statement
      </Link>
      .
    </Checkbox>
  );
};

export { TermsOfServiceCheckbox };
